import React from 'react';

// mui
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// icons
import { VscCallIncoming, VscCallOutgoing } from 'react-icons/vsc';
// utils
import _ from 'lodash';
import moment from 'moment';
import { fTime } from 'src/utils/formatTime';

interface CallLogProps {
  log: {
    from: string;
    label: string;
    direction: 'inbound' | 'outbound';
    duration: number | null;
    callEndTime: string | null;
  };
}

const callDuration = (duration: number) => {
  const momentDuration = moment.duration(duration, 'seconds');
  const seconds = momentDuration.seconds();
  const minutes = momentDuration.minutes();

  const minutesString = minutes > 0 ? `${minutes} min, ` : '';
  const secondsString = minutesString === `` ? `${seconds} seconds` : `${seconds} sec`;
  return minutesString + secondsString;
};

const CallLog: React.FC<CallLogProps> = ({ log, children }) => {
  const theme = useTheme();
  const contrastText = theme.palette.text.secondary;

  const CallIcon = log.direction === 'inbound' ? VscCallIncoming : VscCallOutgoing;
  const durationLabel = log.duration == null ? '' : ` — ${callDuration(log.duration)}`;

  return (
    <Grid
      container
      columnSpacing={{
        xs: 1,
        md: 2,
      }}
      sx={{
        position: 'relative',
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: { xs: 1, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: { xs: 'static', sm: 'absolute' },
              left: { xs: 'unset', sm: '-17.5px' },
              mr: { xs: 1, sm: 3 },
            }}
          >
            <CallIcon size={20} color={contrastText} />
          </Box>
          {log.from}
        </Typography>
        <Typography variant="body2" color={contrastText}>
          {fTime(log.callEndTime)}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {log.label}
        </Typography>
        <Typography variant="body2">
          {_.startCase(log.direction)} call{durationLabel}
        </Typography>
        {children}
      </Grid>
    </Grid>
  );
};

export default CallLog;
